module.exports = __webpack_public_path__ + "img/Pic_Text_TCP_Title.b57c0ac9.png";